import { sleep } from '../lib/tools';
import * as focusTrap from 'focus-trap';

export default class SiteSearch {
  init() {
    
    this.isOpen = false;
    this.trap = focusTrap.createFocusTrap(this.node);

    window.addEventListener('site-search__invoke', (e) => {
      this.open();
    });
    
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    });

    this.node.addEventListener('click', (e) => {
      this.close();
    });

    this.outlets.form.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    
  }

  async open() {
    this.isOpen = true;
    
    this.node.classList.add('state-show');
    
    await sleep(1);
    
    if (!this.isOpen) {
      return;
    }
    
    this.node.classList.add('state-animate');
    
    await sleep(500);

    if (!this.isOpen) {
      return;
    }

    this.trap.activate();
  }

  async close() {
    this.isOpen = false;
    
    this.node.classList.remove('state-animate');
    
    await sleep(500);
    
    if (this.isOpen) {
      return;
    }
    
    this.trap.deactivate();

    this.node.classList.remove('state-show');
    
    await sleep(1);
  }
}
